<template>
  <div>
    <v-btn fab icon @click="$router.go(-1)" >
      <v-icon style="font-weight: bold; font-size: 2.5rem">chevron_left</v-icon>
    </v-btn>
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <div v-else>

<div v-if="schema != null">
  <v-container>
    <v-layout align-center justify-center row wrap>
  <div  id="btn_container">
    <v-btn :disabled="pagination.page <= 1" @click="--pagination.page" icon>
      <v-icon >keyboard_arrow_left</v-icon>
    </v-btn>

    <v-btn :disabled="pagination.page >= pagination.count" @click="++pagination.page" icon>
      <v-icon>keyboard_arrow_right</v-icon>
    </v-btn>
  </div>
    </v-layout>
  </v-container>

  <v-data-iterator
      :items="forms"
      :rows-per-page-items="rowsPerPageItems"
      content-tag="v-layout"
      :pagination.sync="pagination"
      row
      wrap
  >
    <template v-slot:item="props">
  <v-container>
    <v-layout align-center justify-center row>
      <v-flex elevation-24 xs12 lg8>
        <div  style="text-align: center;color:gray; margin-bottom: 2rem; margin-top: 2rem" id="document-name">
          <v-icon>account_box</v-icon>
          <h2 style="text-align: center">-----  {{schema.name}}  -----</h2>
          <span>Dokument {{pagination.page}} z {{pagination.count}}</span>
        </div>

      <div v-for="field in fields">

        <table-view v-if="field.type === fieldType.TABLE" :context="createContext(props.item)"  :table="field" :form_id="props.item.id" :rows_amount="getFormFieldValue(props.item,field)" @loading="updateLoading = $event" />

        <div v-else-if="field.type === fieldType.PERMAMENT">{{ props.item[header.value] }}</div>

        <div v-else-if="field.type === fieldType.SIGNATURE">
          <img v-if="getFormFieldValue(props.item,field) != null && getFormFieldValue(props.item,field).length >10 " @click="openImage(getFormFieldValue(props.item,field),'image/png')" class="imageField"
               :src="'data:image/png;base64,'+getFormFieldValue(props.item,field)" />
          <div v v-else>Brak</div>
        </div>

        <div v-else-if="field.type === fieldType.PHOTO">
          <img v-if="getFormFieldValue(props.item,field) != null && getFormFieldValue(props.item,field).length >10 " @click="openImage(getFormFieldValue(props.item,field),'image/jpg')" class="imageField"
               :src="'data:image/jpg;base64,'+getFormFieldValue(props.item,field)" />
          <div v-else>Brak</div>
        </div>

        <div v-else-if='field.type === fieldType.ARCHIVE'>
          <Archive v-if="getFormFieldValue(props.item,field) != null " :edit="editable" :archive="getFormFieldValue(props.item,field)" />
          <div v-else>Brak</div>
        </div>


        <div v-else-if='field.type === fieldType.RELATED '>
          <Related :code="getFormFieldValue(props.item,field)" :field="field" />
        </div>

        <div v-else-if='field.type === fieldType.DEPEND '>
          <Depend :code="getFormFieldValue(props.item,field)" :field="field" />
        </div>

        <div v-else>
          <v-text-field readonly style="margin: 2rem 2rem " :label="field.name" :value="getFormFieldValue(props.item,field)"></v-text-field>
        </div>
        
      </div>

        <v-flex>
          <v-btn
              @click="$router.push('/document/schema/' +$route.params.schemaId + '/form/' +props.item.id +'/edit')"
              color="primary">
            Edytuj
          </v-btn>
          <ArchiveManager :formId="props.item.id" :schemaId="$route.params.schemaId">
            <template v-slot:activator="{data}">
              <v-btn @click="data.load()" v-on="data.on" color="teal darken-4"  dark>
                Załaduj archiwum
              </v-btn>
            </template>
          </ArchiveManager>
        </v-flex>

      </v-flex>

    </v-layout>
  </v-container>
  </template>
  </v-data-iterator>
  </div>
    </div>
</div>
</template>

<script>
import ArchiveManager from "@/components/form/ArchiveManager";
import fieldType from "@/enums/fieldType";
import context from "@/plugins/Context";
import CustomField from "@/components/form/view/CustomField";
import FormAdapter from "@/plugins/FormAdapter";
export default {
  name: "ViewDocuemnts",
  components:{
    ArchiveManager,
    CustomField
  },
  computed: {
    fields(){
      return this.schema.fields
    }
  },
  data(){
    return {
      rowsPerPageItems : [1],
      fieldType,
      loading : true,
      context,
      schema : {},
      forms : [],
      pagination:{
        rowsPerPage: 1,
      }
    }
  },
  methods:{
    createContext(records) {
      return context.createFullFormContext(this.fields, records)
    },
    getFormFieldValue(form,field){
      return form.results.find(el => el.order == field.order).value
    }
  },
  created() {
    this.loading = true
    let schema = this.$http.get('schema/' + this.$route.params.schemaId)
    let forms = this.$http.get('document/schema/' + this.$route.params.schemaId + '/briefcase/' + this.$route.params.briefcaseGuid + '/all')

    Promise.all([schema,forms]).then(data =>{
      this.schema = data[0].data
      this.forms = data[1].data
      this.pagination.count = this.forms.length
      this.loading = false

      let adapter = new FormAdapter(this.schema.fields, this.schema.confirmation, this.schema.type);
      adapter.loadForms(this.forms)
    })
  }
}
</script>

<style scoped>
#btn_container{
  margin-bottom: -2rem;
}
</style>